import {useState} from 'react';
import {Button, Grid, useTheme, useMediaQuery} from "@mui/material";
import Form from "./form";
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import ModalForm from './modalForm';
import {Form as FormRouterDom, useFetcher, useNavigation, useSubmit} from 'react-router-dom';
import SendIcon from '@mui/icons-material/Send';
import CircularProgress from '@mui/material/CircularProgress';

export const Autoform = ({
                             patchID = null,
                             fields,
                             formHook,
                             submitButton,
                             onSubmit = null,
                             formName,
                             revalidator,
                             newWindowFunction = null,
                             additionalButton = null,
                             /*config, /**
                             ={
                                 formName,
                                 formHook,
                                 submitButton,
                                 patchID,
                                 renderChildForm
                             } */
                             setTriggerFetch = null, // Pass setTriggerFetch to nested forms
                             ...props
                         }) => {
    const [showModal, setShowModal] = useState(false);
    const [formToOpen, setFormToOpen] = useState(null);
    const [fieldClicked, setFieldClicked] = useState(null);
    const [fieldClickedValue, setFieldClickedValue] = useState(null);

    const handleShowModal = () => setShowModal(true);
    const submit = useSubmit();
    const fetcher = useFetcher();
    const navigation = useNavigation();
    const isSubmitting = navigation.state === 'submitting' || formHook.formState.isSubmitting;
    const isLoading = navigation.state === 'loading';
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    return (
        <>
            <Grid
                item
                xs={12}
                sx={{
                    padding: isMobile ? '8px' : '16px', // Отступы для мобильной и десктопной версии
                }}
            >
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="uk">
                    <form
                        style={{
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: isMobile ? '8px' : '16px', // Отступы между элементами
                        }}
                        method="post"
                        encType="multipart/form-data"
                        onSubmit={formHook.handleSubmit(onSubmit)}
                    >
                        <Grid
                            container
                            spacing={isMobile ? 1 : 2}
                            direction="column"
                            sx={{
                                '.btn': {
                                    fontSize: isMobile ? '0.875rem' : '1rem', // Размер текста кнопки
                                    padding: isMobile ? '8px 12px' : '12px 16px', // Отступы внутри кнопки
                                },
                            }}
                        >
                            <Form
                                fields={fields}
                                hook={formHook}
                                setFormToOpen={setFormToOpen}
                                handleShowModal={handleShowModal}
                                setFieldClicked={setFieldClicked}
                                setFieldClickedValue={setFieldClickedValue}
                                revalidator={revalidator}
                                newWindowFunction={newWindowFunction}
                                {...props}
                            />
                            <Grid
                                item
                                container
                                spacing={1}
                                sx={{
                                    justifyContent: isMobile ? 'center' : 'flex-start', // Выравнивание кнопок
                                }}
                            >
                                <Grid item>
                                    <Button
                                        disabled={isSubmitting || isLoading}
                                        variant="contained"
                                        type="submit"
                                        className="btn flex gap-2"
                                        endIcon={<SendIcon/>}
                                    >
                                        {isSubmitting
                                            ? 'Надсилаємо...'
                                            : isLoading
                                                ? "Завантаження..."
                                                : "Надіслати"}
                                    </Button>
                                </Grid>
                                {additionalButton && (
                                    <Grid item>{additionalButton}</Grid>
                                )}
                            </Grid>
                        </Grid>
                    </form>
                </LocalizationProvider>
            </Grid>
            {formToOpen && (
                <Grid
                    item
                    xs={12}
                    sx={{
                        padding: isMobile ? '8px' : '16px', // Отступы внутри модального окна
                    }}
                >
                    <ModalForm
                        patchID={patchID}
                        show={showModal}
                        formName={formToOpen}
                        parentFormName={formName}
                        fieldClicked={fieldClicked}
                        fieldClickedValue={fieldClickedValue}
                        revalidator={revalidator}
                        setShowModal={setShowModal}
                    />
                </Grid>
            )}
        </>
    );
};
